import type { WithdrawResponse } from '@mobi/account/Areas/Withdraw/Utils/types'
import { trackOptimoveEvent } from './optimove'

export const trackOptimoveWithdrawalPercentage = (withdrawalResponse: WithdrawResponse) => {
  const { balance, withdrawalAmount } = withdrawalResponse
  const fraction = withdrawalAmount / (balance + withdrawalAmount)
  const percentage = Math.floor(fraction * 100)

  trackOptimoveEvent({ eventName: 'withdrawal', data: { percentage } })
}
